// WaterMonitoring.tsx
import React, { useEffect, useState } from 'react';
import parameterSvc from '../../services/api/parameter';
import dayjs from "dayjs";
import { useAtom } from 'jotai';
import { waterMonitoring } from '../../store/atoms/waterMonitoring.atom';
import ReactSelectComponent from '../../components/react-select';
import { listDeviceStatus } from '../../utils/helper';
import { useResponsive } from '../../hooks/mediaQuery';
import { useTranslation } from 'react-i18next';
// Model

const WaterMonitoring = () => {
    const [waterMonitoringData] = useAtom(waterMonitoring);
    const [lookupParameter, setLookupParameter] = useState<any[]>([]);
    const [visibleParameter, setVisibleParameter] = useState<any[]>([]);
    const { isXs } = useResponsive();
    const { t } = useTranslation();

    const getLookupParameter = async () => {
        try {
            const res = await parameterSvc.getAll({ pageIndex: 1, pageSize: 20 });
            let data = res.content.items.map((item) => {
                return {
                    ...item,
                    value: item.id,
                    label: item.name,
                }
            })
            setLookupParameter(data);
            setVisibleParameter(data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getLookupParameter();
    }, []);

    const defaultColumns = [
        {
            header: t('monitor.table.stt'),
            accessor: "stt",
            sortable: false,
        },
        {
            header: t('monitor.table.stationName'),
            accessor: "stationName",
            sortable: false,
            className: "min-w-[150px]",
        },
        {
            header: t('monitor.table.measurementTime'),
            accessor: "waterMonitoringTime",
            sortable: false,
        },
    ];

    const columns = defaultColumns.concat(
        visibleParameter && visibleParameter.length > 0
            ? visibleParameter.map((item) => ({
                header: item.name,
                accessor: item.id,
                sortable: false,
            }))
            : []
    );

    if (!waterMonitoringData) return <div className="flex items-center justify-center h-full">Waiting for data...</div>;

    return (
        <div className="page-wrapper h-full">
            <div className="annotate flex gap-2 bg-white p-2 rounded-lg mb-2">
                {listDeviceStatus.map((status) => (
                    <div key={status.value} className="flex items-center gap-1">
                        <div className={`dot ${status.color}`}></div>
                        <span className={`${isXs ? 'text-xs' : 'text-sm'} text ${status.color}`}>{t(`${status.label}`)}</span>
                    </div>
                ))}
            </div>
            <ReactSelectComponent
                options={
                    visibleParameter.length === lookupParameter.length ?
                        lookupParameter : [{ label: t('monitor.filter.selectAll'), value: '*' }, ...lookupParameter]}
                value={visibleParameter}
                onChange={(selected: any) => {
                    if (!selected || selected.length === 0) {
                        setVisibleParameter([]);
                        return;
                    }
                    if (selected.some((option: any) => option.value === '*')) {
                        setVisibleParameter(lookupParameter);
                    } else {
                        setVisibleParameter(selected);
                    }
                }}
                isMulti
                noOptionsMessage={t('monitor.filter.allParametersSelected')}
                closeMenuOnSelect={visibleParameter.length === lookupParameter.length}
                placeholder={t('monitor.filter.selectParameter')}
            />
            <div className="relative w-full overflow-x-auto rounded-lg border border-gray-200 shadow-sm bg-white mt-4">
                <table className="min-w-full text-sm text-left text-gray-700">
                    <thead className="bg-gray-200 text-sm font-semibold text-gray-600">
                        <tr>
                            {columns && columns.map((column, index) => (
                                <th
                                    key={index}
                                    className={`${column.className} px-4 py-3 text-left`}
                                >
                                    <div className="">
                                        <span>{column.header}</span>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {waterMonitoringData && waterMonitoringData.length > 0 && waterMonitoringData.map((item: any, index: number) => (
                            <tr key={index} className={`border-b hover:bg-gray-100 ${index % 2 === 0 ? "bg-gray-50" : ""}`}>
                                {columns.map((column: any, colIdx) => {
                                    const data = item.data.find((item: any) => item.parameterId === column.accessor)
                                    const showStatus = data?.value && column.accessor !== "stt" && column.accessor !== "stationName" && column.accessor !== "waterMonitoringTime";
                                    const status = (data && listDeviceStatus.find((status) => status.value === data.deviceStatus)?.color) || "gray";

                                    return (
                                        <td key={colIdx} className="first:pl-4 px-2 py-2">
                                            <div className="flex items-center gap-1">
                                                {showStatus && <div className={`w-[18px] h-[18px] rounded-full bg-${status}`}></div>}
                                                {column.accessor === "stt" ? index + 1 :
                                                    column.accessor === "stationName" ? item.stationName
                                                        : column.accessor === "waterMonitoringTime" ? dayjs(item.waterMonitoringTime).format("DD/MM/YYYY HH:mm:ss")
                                                            : data?.value || "-"}
                                            </div>
                                        </td>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default WaterMonitoring; 